import React from 'react';

const FooterComponent = () => {
    return <div className="align-items-center bg-black flex-row mt-4 py-4">
        <p className="mb-0 text-center text-white">
            Made by: Luis Bernal, Adrian Carcache, Humberto De Leon y Jose
            Urriola @ Hackathon Eurus 2019
          </p>
    </div>;
};

export default FooterComponent;